import { LookupDTO } from "./lookup.model";

export class ReceiptDTO{
  public ID : number;
  public FK_DueInvoice : number;
  public ReceiptDate : Date;
  public EntryAccountDate : Date;
  public Amount : number;
  public Account : LookupDTO;
  public STSProtocollo : string;  
  public STSSendingResponse: STSSendingResponseEnum;
  public FK_NamirialPayLink: number;

}
export class ReceiptListSTS{
public ID : number;
public Section: string;
public Identifier: number;
public ReceiptDate: Date;
public FK_Company: number;
public FK_Customer: number;
public FK_Invoice: number;
public FK_DueInvoice:number;
public Customer: string;
public STSProtocollo: string;
public STSEsitoChiamata: string;
public STSSendingResponse: string;
public Ammount: number;

}

//SOLO CLIENT
export class ReceiptsSTSTotals {
  public TotalReceipts: number;  
  public TotalReceiptAmount: number;
}
export class ReceiptFilterDTO {
    ID: number;
    ReferenceYear: number;
    ReferenceNumber: number;
    ReferenceSection: string;        
    BillingFromDate: Date = new Date();
    BillingToDate: Date;
    FK_Customer : number;
    FK_Company: number;
    STSProtocollo: string;
}

export enum STSSendingResponseEnum
{        
    Async_InElaborazione = 0,
    Async_InCorsoDiElaborazione = 1,
    Async_OK = 2,
    Async_ElaboratoConErrori = 3,
    Async_ScartatoInElaborazione = 5,
    Async_ScartatoInAccoglienza = 9,
    Sync_OK = 100,
    Sync_ErroreBloccante = 101,
    Sync_AccoltoConSegnalazioni = 102
}